import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const sizeMap = {
  sm: { spinner: 'w-4 h-4', text: 'text-xs' },
  md: { spinner: 'w-7 h-7', text: 'text-sm' },
  lg: { spinner: 'w-10 h-10', text: 'text-base' },
  xl: { spinner: 'w-14 h-14', text: 'text-lg' },
};

const LoadingSpinner = ({
  size = 'md',
  text,
  showText = true,
  className = '',
}) => {
  const { t } = useLanguage();
  const displayText = text ?? t('loading');
  const { spinner, text: textSize } = sizeMap[size] ?? sizeMap.md;

  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 ${className}`}
      role="status"
      aria-label={displayText}
    >
      <div
        className={`${spinner} rounded-full border-2 border-stone-200 dark:border-stone-700 border-t-amber-600 animate-spin`}
      />
      {showText && (
        <p className={`${textSize} text-stone-500 dark:text-stone-400 font-medium`}>
          {displayText}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
